'use client'
import React from 'react'
import Image from 'next/image'

const marqueeItems = [
   'AI & ML Development',
   'Ecommerce Development',
   'Web Application Development',
   'Custom Software Development',
   'Progressive Web App Development',
   'Mobile App Development',
   'Blockchain Development',
   'Testing and QA Services',
   'Web design Services',
]

export default function Marquee() {
   const handleMouseOver = (e) => {
      e.target.stop()
   }

   const handleMouseOut = (e) => {
      e.target.start()
   }

   return (
      <section className="section_primary_bg marquee marqueeImgs">
         <marquee
            className="styled-text"
            behavior="scroll"
            direction="left"
            scrollamount="20"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
         >
            {marqueeItems.map((item, index) => (
               <React.Fragment key={index}>
                  <Image 
                     src="/assets/svg/discover/benzatinelogo.svg" 
                     alt="Logo"
                     width={48}
                     height={49}
                  />
                  {item}
               </React.Fragment>
            ))}
            <Image 
               src="/assets/svg/discover/benzatinelogo.svg" 
               alt="Logo"
               width={48}
               height={49}
            />
         </marquee>
      </section>
   )
}
